var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarioAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_376",
    "data-name": "Grupo 376",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.407,
    height: 41.151,
    viewBox: "0 0 38.407 41.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_227",
    "data-name": "Trazado 227",
    d: "M293.525,145.634h-4.8v-2.058a.686.686,0,0,0-.686-.686h-4.8a.686.686,0,0,0-.686.686v2.058H267.463v-2.058a.686.686,0,0,0-.686-.686h-4.8a.686.686,0,0,0-.686.686v2.058h-4.8a.684.684,0,0,0-.685.686v37.035a.684.684,0,0,0,.685.686h37.037a.684.684,0,0,0,.686-.686V146.32A.684.684,0,0,0,293.525,145.634Zm-9.6-1.372h3.429v4.115h-3.429v-4.115Zm-21.262,0h3.429v4.115h-3.429v-4.115ZM257.175,147h4.116v2.058a.686.686,0,0,0,.686.686h4.8a.686.686,0,0,0,.686-.686V147h15.089v2.058a.686.686,0,0,0,.686.686h4.8a.686.686,0,0,0,.686-.686V147h4.115v6.174H257.175Zm0,35.666V154.549h35.665V182.67Z",
    transform: "translate(-255.804 -142.89)",
    fill: "#409cce"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_228",
    "data-name": "Trazado 228",
    d: "M280.054,157.539H261.536v19.89H287.6v-19.89h-7.544Zm-4.8,1.372h4.8v4.8h-4.8Zm4.8,10.973h-4.8v-4.8h4.8Zm-10.973-4.8h4.8v4.8h-4.8Zm0-6.173h4.8v4.8h-4.8Zm-6.173,0h4.8v4.8h-4.8Zm0,6.173h4.8v4.8h-4.8Zm4.8,10.973h-4.8v-4.8h4.8Zm6.173,0h-4.8v-4.8h4.8Zm6.173,0h-4.8v-4.8h4.8Zm6.173,0h-4.8v-4.8h4.8Zm0-6.173h-4.8v-4.8h4.8Zm0-10.973v4.8h-4.8v-4.8Z",
    transform: "translate(-255.363 -141.764)",
    fill: "#409cce"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarioAzul);
export default __webpack_public_path__ + "static/media/calendario-azul.daebaf58fdca538d0e6e64b77b223f04.svg";
export { ForwardRef as ReactComponent };